import { render, staticRenderFns } from "./area-tree.vue?vue&type=template&id=905e57f6&scoped=true&"
import script from "./area-tree.vue?vue&type=script&lang=js&"
export * from "./area-tree.vue?vue&type=script&lang=js&"
import style0 from "./area-tree.vue?vue&type=style&index=0&id=905e57f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e57f6",
  null
  
)

export default component.exports